<template>    
        <section class="footermenu">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1">
                        <div class="footermenu__boxes">
                            <div class="footermenu__box">
                                <v-btn 
                                    color="primary"
                                    large
                                    text
                                    :to="{ name: 'contact' }"
                                >Kontakt</v-btn>
                            </div>
                            <div class="footermenu__box">
                                <v-btn 
                                    color="primary"
                                    large
                                    text
                                    :to="{ name: 'rules'}"
                                >Pravidla soutěže</v-btn>
                            </div>
                            <div class="footermenu__box">
                                <v-btn 
                                    color="primary"
                                    large
                                    text
                                    :to="{ name: 'home', hash: '#mapa-hospod' }"
                                >Mapa hospod</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
</template>

<script>
    export default {
        name: 'FooterMenu',
    }
</script>

